import { render, staticRenderFns } from "./InfoButtons.vue?vue&type=template&id=362e6aed&scoped=true"
import script from "./InfoButtons.vue?vue&type=script&lang=ts"
export * from "./InfoButtons.vue?vue&type=script&lang=ts"
import style0 from "./InfoButtons.vue?vue&type=style&index=0&id=362e6aed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362e6aed",
  null
  
)

export default component.exports